// if border-box is used, the width will be the same as the scrollWidth
// if content-box is used, need to subtract the padding and border
export const setInputAutoWidth = (ref: HTMLInputElement) => {
  ref.style.width = '0px';

  const { borderLeftWidth, borderRightWidth, boxSizing, paddingLeft, paddingRight } =
    window.getComputedStyle(ref);

  let width = ref.scrollWidth;

  if (boxSizing === 'content-box') {
    width -= parseInt(paddingLeft, 10);
    width -= parseInt(paddingRight, 10);
    width -= parseInt(borderLeftWidth, 10);
    width -= parseInt(borderRightWidth, 10);
  }

  ref.style.width = `${width}px`;
};
